import { useEffect } from 'react'

import { useGigyaSignInScreen } from '@hooks/gigya/useGigyaSignInScreen'
import { useGigyaSignOutUser } from '@hooks/gigya/useGigyaSignOutUser'
import { createUserProfileFromGigyaResponse } from '@hooks/gigya/useLoadGigya'
import { useGigyaStore } from '@stores/gigya'

type UseGigyaSessionReturn = {
  isAuthenticated: boolean
  signIn: () => void
  signOut: () => void
  error: Error | null
  userName: string
  user: Gigya.UserProfile | null
}

export const getAccountInfo = (): Promise<any> => {
  return new Promise((resolve, reject) => {
    window.gigya?.accounts.session.verify({
      callback: (res: any) => {
        if (res.errorCode === 0) {
          window.gigya?.accounts.getAccountInfo({
            callback: (res: any) => {
              if (res.errorCode === 0) {
                resolve(res)
              } else {
                reject(res)
              }
            },
          })
        } else {
          reject(res)
        }
      },
    })
  })
}

export const useGigyaSession = (): UseGigyaSessionReturn => {
  const [gigyaStore, setGigyaStore] = useGigyaStore()
  const { showUIAuthHandler, error } = useGigyaSignInScreen()
  const { signOutUser } = useGigyaSignOutUser()

  // Check if the user is authenticated
  useEffect(() => {
    if (gigyaStore.isLoaded) {
      const getGigyaUserAccount = async () => {
        try {
          const res = await getAccountInfo()
          setGigyaStore({ user: createUserProfileFromGigyaResponse(res) })
        } catch (error) {
          console.error('Gigya user account error:', error)
        }
      }

      getGigyaUserAccount()
    }
  }, [gigyaStore.isLoaded, setGigyaStore])

  const user = gigyaStore.user ?? null
  const isAuthenticated = !!user

  const userName = [user?.profile?.firstName, user?.profile?.lastName].filter(Boolean).join(' ')

  return {
    isAuthenticated,
    signIn: showUIAuthHandler,
    signOut: signOutUser,
    userName,
    user,
    error,
  }
}
